import { ACTION_SET_MOBILE_CONNECTION_DATA } from "./names.js";

export default function mobileConnectionInfo(state = {}, action) {
  switch (action.type) {
    case ACTION_SET_MOBILE_CONNECTION_DATA:
      return action.payload;

    default:
      return state;
  }
}
